import { post } from '../../util/fetch';
import { TokenResponse } from './TokenResponse';

export const refreshToken = () => {
  return post<TokenResponse>('/api/v1/administrator/token/re-issue');
};
